import React from 'react';
import './ButtonWhatsapp.css';

const BotonWhatsapp = () => {
  const numeroTelefono = '573127431631'; // Tu número de teléfono
  const mensajePredeterminado = encodeURIComponent('¡Hola! Quisiera obtener más información.');
  const enlaceWhatsapp = `https://wa.me/${numeroTelefono}?text=${mensajePredeterminado}`;

  return (
    <a 
      href={enlaceWhatsapp} 
      className="btn-whatsapp-flotante" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
    >
      <div className="icon-circle">
        <svg 
          viewBox="0 0 24 24" 
          width="24" 
          height="24" 
          fill="#25d366"
        >
          <path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.97-.15.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.15-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.03 2.61.12.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.44.53.6.19 1.15.16 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.18-.47-.3z"/>
        </svg>
      </div>
      <span className="btn-texto">Escríbenos</span>
    </a>
  );
};

export default BotonWhatsapp;
